import { ExchangeRate, LoadableState, OrderExchangeSummaryData } from '@eih-netbroker/common';

export enum OrderFormSourceComponent {
  Modal = 'modal',
  Widget = 'widget',
}

// This stores exchange data captured at the point of pressing the button with the checkOrder text.
// This is done, so that exchange data is used only from this captured state when submitting orders,
// and live/updating data is ignored further down the call chain.
export type CapturedExchangeData = {
  summary: OrderExchangeSummaryData | undefined;
  exchangeRate: LoadableState<ExchangeRate> | undefined;
};

export enum OrderFlowStep {
  Form = 'form',
  Confirmation = 'confirmation',
  TwoFactor = 'twoFactor',
  ReceivedMessages = 'receivedMessages',
}
